/*
  Kademeli hediye senkronu. Sepet tutarı (hediye satırları hariç) eşiği geçince hediyeyi
  "_hediye: otomatik" özelliğiyle ekler, altına düşünce yalnızca otomatik eklenenleri çıkarır.
  Hediyeyi ücretsiz yapan Shopify otomatik indirimidir (sipariş başına 1 adet); bu betik yalnızca
  sepete koyar. Ayarlar layout/theme.liquid içindeki window.zrGifts'ten gelir.
*/
(function () {
  var cfg = window.zrGifts;
  if (!cfg || !cfg.tiers || !cfg.tiers.length) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var giftIds = cfg.tiers.map(function (t) { return t.variant; });
  var busy = false, again = false;

  function json(url, body) {
    return fetch(root + url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function plan(cart) {
    var base = 0, lines = {};
    cart.items.forEach(function (it, i) {
      if (giftIds.indexOf(it.variant_id) === -1) { base += it.final_line_price; return; }
      (lines[it.variant_id] = lines[it.variant_id] || []).push({ key: it.key, qty: it.quantity, auto: it.properties && it.properties._hediye === 'otomatik' });
    });
    var add = [], updates = {};
    cfg.tiers.forEach(function (t) {
      var own = lines[t.variant] || [];
      var eligible = cart.item_count > 0 && base >= t.cents;
      var autos = own.filter(function (l) { return l.auto; });
      if (eligible) {
        if (!own.length) add.push({ id: t.variant, quantity: 1, properties: { _hediye: 'otomatik' } });
        // Otomatik eklenen hediye tek adet kalır
        autos.forEach(function (l, i) { var want = i === 0 ? 1 : 0; if (l.qty !== want) updates[l.key] = want; });
      } else {
        autos.forEach(function (l) { updates[l.key] = 0; });
      }
    });
    return { add: add, updates: updates };
  }

  function refreshUI(changed) {
    if (!changed) return;
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    fetch(root + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var parse = function (html, sel) { return new DOMParser().parseFromString(html, 'text/html').querySelector(sel); };
      var d = parse(s['cart-drawer'], '#CartDrawer'), bubble = document.getElementById('cart-icon-bubble');
      if (d) {
        var open = drawer.classList.contains('active');
        document.getElementById('CartDrawer').innerHTML = d.innerHTML;
        var ov = drawer.querySelector('#CartDrawer-Overlay');
        if (ov && open) ov.addEventListener('click', drawer.close.bind(drawer));
      }
      if (bubble && s['cart-icon-bubble']) { var b = parse(s['cart-icon-bubble'], '.shopify-section'); if (b) bubble.innerHTML = b.innerHTML; }
    });
  }

  function sync() {
    if (busy) { again = true; return; }
    busy = true;
    json('cart.js').then(function (cart) {
      var p = plan(cart), steps = Promise.resolve(), changed = false;
      if (Object.keys(p.updates).length) { changed = true; steps = steps.then(function () { return json('cart/update.js', { updates: p.updates }); }); }
      if (p.add.length) { changed = true; steps = steps.then(function () { return json('cart/add.js', { items: p.add }); }); }
      return steps.then(function () { refreshUI(changed); });
    }).catch(function () {}).then(function () {
      busy = false;
      if (again) { again = false; sync(); }
    });
  }

  // Sepet her değiştiğinde (ürün sayfası, çekmece, öneriler) ve sayfa açılışında
  // PUB_SUB_EVENTS Dawn'da üst düzey const: window'da değil, doğrudan adla erişilir
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(sync, 50); });
  document.addEventListener('zr:cart-changed', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
